import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import router from "./routes/Router"
import ModConfig from "./modules/ModConfig"
//import ModParticipant from "./modules/ModParticipant"

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

let notFound = false

require('./scss/default.scss')

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

ModConfig.load(window.location.href.split("?")[0]).then(config => {
  let messages = config.messages || {}
  const i18n = new VueI18n({
    locale: "de",
    messages
  })
  if (config.specs) {
    Vue.prototype.$specs = config.specs
  } else {
    notFound = true
  }

  new Vue({
    router,
    i18n,
    mounted() {
      const supportedLanguages = ["de", "en", "fr", "it"];
      const getQueryParam = (name, url = window.location.href) => {
        name = name.replace(/[[\]]/g, "\\$&")
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url)

        if (!results) return null
        if (!results[2]) return null
        return decodeURIComponent(results[2].replace(/\+/g, ' '))
      }
      const supported = (() => {
        const nav = navigator.userAgent.toLocaleLowerCase()
        const isNotIe9 = ((nav.indexOf('msie') != -1) ? parseInt(nav.split('msie')[1]) : 11) !== 9
        const supportSvg = !!(document.createElementNS && document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect)
        return isNotIe9 && supportSvg
      })();
      /*
      const nextHandler = ()=>{
        this.$specs.withWelcome
        ? this.$router.replace("/welcome")
        : this.$specs.withInstructions
        ? this.$router.replace("/instructions")
        : this.$specs.tanProtected
        ? this.$router.replace("/tan")
        : this.$specs.registrationNeeded
        ? this.$router.replace("/register")
        : this.$router.replace("/vip")
      }*/
      if (supported) {
        if (notFound) {
          this.$router.replace("/notfound")
        } else {
          let lang = getQueryParam("lang")
          if (lang) {
            lang = supportedLanguages.includes(lang) ? lang : "fr"
            this.$router.replace({ path: "/", query: { lang: lang } })
          } else {
            this.$router.replace("/")
          }
        }
      } else {
        this.$router.replace("/notsupported")
      }

    },
    render: h => h(App),
    el: "#app"
  })

}).catch(err => {
  console.error(err);
  router.replace("/notfound")
})
